// Casa Galênê Cleaning — content & media

export const CONTACT = {
  email: "info@casagalenecleaning.com",
  phone: "0439 315 885",
  phoneRaw: "0439315885",
  base: "Jervis Bay, Australia",
};

export const AREAS = ["Jervis Bay", "Sydney", "Adelaide", "Townsville", "Airlie Beach"];

export const IMAGES = {
  logo: "/logo-cgc.png",
  logoScene: "https://customer-assets-7cd3h4nn.emergentagent.net/job_dbb775dc-f952-46ba-aa95-074b1067a525/artifacts/5txjnu4r_Untitled%20design%20%282%29.webp",
  heroOcean: "https://images.unsplash.com/photo-1765999906700-2d4dfd392966?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxtZWRpdGVycmFuZWFuJTIwdmlsbGElMjBvY2VhbnxlbnwwfHx8fDE3ODUxMjQ5MDZ8MA&ixlib=rb-4.1.0&q=85",
  villaExterior: "https://images.unsplash.com/photo-1673403731036-30ef7a4995f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxtZWRpdGVycmFuZWFuJTIwdmlsbGElMjBvY2VhbnxlbnwwfHx8fDE3ODUxMjQ5MDZ8MA&ixlib=rb-4.1.0&q=85",
  luxuryBathroom: "https://images.unsplash.com/photo-1756079664354-34944e001f6d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjA1ODh8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBtaW5pbWFsaXN0JTIwdHJhdmVydGluZSUyMGJhdGhyb29tfGVufDB8fHx8MTc4NTEyNDkwN3ww&ixlib=rb-4.1.0&q=85",
  freshLinen: "https://images.unsplash.com/photo-1634665810235-011d663754e7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxmcmVzaCUyMHdoaXRlJTIwbGluZW4lMjBzdW5saWdodHxlbnwwfHx8fDE3ODUxMjQ5MDZ8MA&ixlib=rb-4.1.0&q=85",
  marbleKitchen: "https://images.unsplash.com/photo-1600566752355-35792bedcfea?q=85&w=2000",
  living: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=85&w=2000",
  terrace: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=85&w=2000",
  olive: "https://images.unsplash.com/photo-1445264618000-f1e069c5920f?q=85&w=1600",
  detail: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?q=85&w=2000",
  poolside: "https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?q=85&w=2000",
};

export const SERVICES = [
  { n: "01", title: "Commercial Cleaning", desc: "Composed, immaculate workplaces and retail spaces — presented to a five-star standard that reflects the calibre of your business, every single day.", img: IMAGES.poolside },
  { n: "02", title: "Post Construction Cleaning", desc: "The final, flawless reveal of a finished build — dust, debris and residue meticulously removed so your new space is ready to be admired.", img: IMAGES.marbleKitchen },
  { n: "03", title: "Residential Cleaning", desc: "Meticulous care for the homes you live and love in, with hospitality-inspired attention to every surface, corner and considered detail.", img: "/med-interior.png" },
  { n: "04", title: "End of Lease Cleaning", desc: "A thorough, bond-back clean that leaves the property spotless and inspection-ready — protecting your deposit and your peace of mind.", img: IMAGES.luxuryBathroom },
  { n: "05", title: "Pre Settlement Cleaning", desc: "A pristine handover for buyers and sellers, ensuring the property is immaculate and welcoming the moment the keys change hands.", img: IMAGES.detail },
  { n: "06", title: "Pre Sale Cleaning", desc: "Present your property at its absolute best for inspections and photography — polished, luminous and styled to captivate every buyer.", img: IMAGES.villaExterior },
  { n: "07", title: "Hospitality Cleaning", desc: "Refined, discreet cleaning for venues, restaurants and boutique stays — upholding the flawless first impression your guests expect.", img: IMAGES.freshLinen },
  { n: "08", title: "Airbnb Cleaning", desc: "Seamless, five-star turnovers between guests, complete with fresh linen presentation and a guest-ready finish, every time.", img: IMAGES.terrace },
  { n: "09", title: "Window Cleaning (Interior & Exterior)", desc: "Crystal-clear glass inside and out — streak-free, spotless and radiant, inviting natural light to fill every room.", img: IMAGES.living },
  { n: "10", title: "Exterior Driveway & Patio Cleaning", desc: "Pressure and detail cleaning that restores driveways, patios and outdoor stone to their original, sun-washed Mediterranean glow.", img: IMAGES.terrace },
  { n: "11", title: "Solar Panel Cleaning", desc: "Gentle, professional panel cleaning that lifts dust and grime to restore efficiency — keeping your investment performing at its best.", img: IMAGES.villaExterior },
];

export const PROCESS = [
  { n: "01", title: "Request a Quote", body: "Share your space and needs. We listen closely and respond with care." },
  { n: "02", title: "Tailored Service Plan", body: "A bespoke plan crafted around your home, schedule and standards." },
  { n: "03", title: "Meticulous Property Care", body: "Hospitality-trained professionals attend to every last detail." },
  { n: "04", title: "Enjoy the Feeling of Home", body: "Return to a space that feels serene, elegant and beautifully cared for." },
];

export const WHY = [
  { title: "Attention to Detail", body: "Nothing overlooked. The difference lives in the details." },
  { title: "Boutique Service", body: "Small by design, so every client feels singular." },
  { title: "Premium Service", body: "A five-star experience from first hello to final reveal — the standard discerning clients return to again and again." },
  { title: "Fully Insured up to $10 Million", body: "Complete public liability cover, so your property and your peace of mind are always protected." },
  { title: "Hospitality Mindset", body: "We care for your home as if welcoming a guest." },
  { title: "Eco-conscious Products", body: "Refined, gentle, and kind to your spaces." },
];

export const TESTIMONIALS = [
  { quote: "Walking back into our home felt like arriving at a five-star villa. Every surface glowed. This is a different standard entirely.", name: "Isabella M.", role: "Private Residence — Sydney" },
  { quote: "Casa Galênê handled our post-construction handover with astonishing precision. Our clients were speechless.", name: "Daniel R.", role: "Luxury Home Builder — Jervis Bay" },
  { quote: "Our Airbnb turnovers are flawless every single time. Guests consistently mention how immaculate the home is.", name: "Sophie L.", role: "Holiday Home Owner — Airlie Beach" },
  { quote: "Calm, discreet and utterly reliable. Our offices have never felt so composed and cared for.", name: "Marcus T.", role: "Commercial Client — Adelaide" },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title);

export const LOCATIONS = [
  {
    name: "Jervis Bay",
    region: "New South Wales",
    img: IMAGES.terrace,
    blurb:
      "Boutique residential, holiday-home and Airbnb cleaning across Jervis Bay, Vincentia, Huskisson and Callala Bay — keeping coastal homes and beach houses immaculate year-round.",
    keywords: "House cleaning · Holiday home turnovers · Estate care",
  },
  {
    name: "Sydney",
    region: "New South Wales",
    img: IMAGES.living,
    blurb:
      "Premium residential and commercial cleaning throughout Sydney — from Eastern Suburbs apartments to Northern Beaches estates, delivered with five-star hospitality precision.",
    keywords: "Residential cleaning · Commercial cleaning · Deep cleaning",
  },
  {
    name: "Adelaide",
    region: "South Australia",
    img: IMAGES.luxuryBathroom,
    blurb:
      "Luxury home and office cleaning across Adelaide and the surrounding suburbs, including post-construction and builders cleans for handover-ready properties.",
    keywords: "Office cleaning · Post construction · Routine maintenance",
  },
  {
    name: "Townsville",
    region: "Queensland",
    img: IMAGES.marbleKitchen,
    blurb:
      "Detail-driven house and commercial cleaning in Townsville — bond cleans, deep cleans and ongoing estate care for North Queensland homes and businesses.",
    keywords: "House cleaning · Bond cleaning · Estate care",
  },
  {
    name: "Airlie Beach",
    region: "Queensland",
    img: IMAGES.poolside,
    blurb:
      "Holiday-home and Airbnb turnover specialists in Airlie Beach and the Whitsundays — seamless, guest-ready presentation for premium short-stay properties.",
    keywords: "Airbnb turnovers · Holiday homes · Deep cleaning",
  },
];
